module.exports = __webpack_public_path__ + "img/icon-hamburger.35f8fd48.svg";